/** Las estaciones en orden numérico: la misma selección en otro orden es la misma. */
export const sortedStations = (ids: readonly number[]): number[] =>
    [...ids].sort((a, b) => a - b);

export const sameStations = (a: readonly number[], b: readonly number[]): boolean => {
    const left = sortedStations(a);
    const right = sortedStations(b);

    return left.length === right.length && left.every((id, index) => id === right[index]);
};

/** La estación elegida cuando es una sola; con ninguna (todas) o con varias, nulo. */
export const singleStation = (ids: readonly number[]): number | null =>
    ids.length === 1 ? ids[0] : null;

/** Cuántas filas muestran los rankings de estaciones antes de ofrecer «Ver las N estaciones». */
export const RANKING_ROWS = 8;
